import PropTypes from 'prop-types'

import DataCentrifuge from '@aytm/app/stats/page/data-centrifuge/DataCentrifuge'

// Embeds the existing data-centrifuge React app. The live Controller is built and owned
// by the DQR shim and threaded in as a prop; when it is absent (e.g. unit rendering of the
// container without a page) nothing renders.
const DataCentrifugeSummary = ({ dcController, tier }) =>
  dcController ? <DataCentrifuge controller={dcController} tier={tier} /> : null

DataCentrifugeSummary.displayName = 'DataCentrifugeSummary'
DataCentrifugeSummary.propTypes = {
  dcController: PropTypes.object,
  state: PropTypes.string,
  tier: PropTypes.string,
  data: PropTypes.object
}
export default DataCentrifugeSummary
